<template>
    <div class="quotation">
        <h2>{{ title }}</h2>
        <p class="tip">
            编号：{{ $route.query.number }}<br />
            价格包含：{{ config.quotationInclude }}<br />
            白卡纸面积{{ $route.query.single }}cm<sup>2</sup>.
        </p>
        <br />
        <table style="width: 100%;" border="1" borderColor="red">
            <tr style="line-height: 0.5rem;">
                <td rowspan="2">报价<br />元/个</td>
                <td colspan="2">用户了解</td>
                <td colspan="2">合伙人了解</td>
            </tr>
            <tr style="line-height: 0.5rem;">
                <td>防伪成本<br />元/个</td>
                <td>回本销售增长率&asymp;<br />单个防伪成本<br />/单个出厂价</td>
                <td>合伙人收益<br />元/个</td>
                <td>提成<br />比例</td>
            </tr>
            <tr v-for="(price, key) in prices">
                <td>{{ price.price.toFixed(4) }}</td>
                <td>{{ price.cost.toFixed(4) }}</td>
                <td>{{ $route.query.price ? (price.cost / $route.query.price * 100).toFixed(2) + '%' : '/' }}</td>
                <td>{{ price.income.toFixed(3) }}</td>
                <td>{{ (price.income / price.price * 100).toFixed(2) }}%</td>
                <!-- <template v-if="rowspan(price.scale, key) > 0">
                    <td :rowspan="rowspan(price.scale, key)">{{ price.scale * 100 }}%
                    </td>
                </template> -->
            </tr>
            <tr>
                <td colspan="5">报价{{ income.toFixed(4) }} 元/个以上增加部分，合伙人提成50%</td>
            </tr>
            <tr>
                <td colspan="5" style="text-align: left; line-height: 0.5rem;">
                    <p v-html="remarkFormater()"></p>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import { getDocQuotationCalculation } from "@/api/docQuotationCalculation"
export default {
    data() {
        return {
            config: {},
            prices: [],
            income: 0,
            title: '',
            list: [
                { checked: false, sort: '1', name: '1. 白卡纸（纸盒/吊牌/挂牌）' },
                { checked: false, sort: '2', name: '2. 不干胶（标签/瓶贴）' },
                { checked: false, sort: '3', name: '3. 单张纸（合格证/说明书/浆糊瓶贴等）' },
                { checked: false, sort: '4', name: '4. 封箱带' },
                { checked: false, sort: '5', name: '5. 瓦楞纸箱面纸' },
                { checked: false, sort: '6.1', name: '6.1 烟包硬盒框架纸' },
                { checked: false, sort: '6.2', name: '6.2 烟包硬盒环保铝箔衬纸' },
                { checked: false, sort: '6.3', name: '6.3 烟包硬盒外壳' },
                { checked: false, sort: '6.4', name: '6.4 烟包软包封签纸' },
                { checked: false, sort: '6.5', name: '6.5 烟包全开硬盒内卡纸' }],
        }
    },
    created() {
        //获取合伙人参数并计算报价
        getDocQuotationCalculation(this.$route.query._).then(res => {
            this.config = res.data
            this.title = this.list.find(item => item.sort == this.config.productType).name
            let _scales = JSON.parse(this.config.expandJson).scales
            // 报价基数
            let basePrice = parseFloat(this.config.materialFactor) * parseFloat(this.$route.query.single) + parseFloat(this.config.incrementalValue)
            // 报价间隔
            let quotationInterval = this.config.quotationInterval * basePrice / 15
            let _first = { price: basePrice, income: basePrice * Object.values(_scales[0]) / 100, cost: basePrice - this.config.originalPrice, scale: Object.values(_scales[0]) / 100 }
            this.prices = [_first]
            let _price = basePrice
            // let _income = basePrice * Object.values(_scales[0]) / 100
            let last_price_index = 0
            for (let i = 1; i < _scales.length - 1; i++) {
                for (let j = 0; j < 5; j++) {
                    _price = _price + quotationInterval
                    let _tempPrice = { price: _price, income: this.prices[last_price_index].income + (_price - this.prices[last_price_index].price) * Object.values(_scales[i]) / 100, cost: _price - this.config.originalPrice, scale: Object.values(_scales[i]) / 100 }
                    this.prices.push(_tempPrice)
                    console.log(this.prices[last_price_index].price)
                    this.income = _price
                }
                last_price_index += 5
            }
        })
    },
    methods: {
        computeIncome(index) {
            const E$5 = this.prices[0].price * this.prices[0].scale
            if (index == 0)
                return E$5.toFixed(3)
            else
                return (E$5 + (this.prices[index].price - this.prices[0].price) * this.prices[index].scale).toFixed(3)
        },
        rowspan(scale, key) {
            if (key == 0 || this.prices[key].scale != this.prices[key - 1].scale)
                return this.prices.filter(item => item.scale == scale).length
            else
                return -1

        },
        remarkFormater() {
            return this.config.remark ? this.config.remark.replaceAll('\n', '<br/>') : ''
        }
    }
}
</script>
<style lang="scss" scoped>
.quotation {
    padding: 0.32rem;
    font-size: .4rem;

    .title,
    h1,h2,
    .button {
        text-align: center;
    }

    .tip {
        text-align: center;
        font-size: 0.3rem;
        line-height: 0.4rem;
    }

    table {
        border-collapse: collapse;
        margin-bottom: 0.8rem;
        border: 2px solid rgb(55, 53, 53);

        tr {
            td {
                border: 1px solid rgb(55, 53, 53);
                text-align: center;
                padding: 0.2rem;
                font-size: 0.3rem;
                vertical-align: middle;
            }
        }
    }

    h2 {
        font-size: 0.48rem;
        line-height: 1.3rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation2/quotation-result.vue